import React from 'react';
import { Box, Typography } from '@mui/material';
import MapPage from '../MapPage';

const GISPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        GIS - Geographic Information System
      </Typography>
      <MapPage />
    </Box>
  );
};

export default GISPage;
